/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    function boxmanInit() {
        if (!document.body.classList.contains('admin')) {
            return;
        }
        $("#dialog").on("dialogopen", function () {
            tryUntilReady(function () {
                var boxForm = document.querySelector('.boxmanBoxForm #title');
                return !!boxForm;
            }, function () {
                initMultiselect();
            });
        });
    }
    function tryUntilReady(isReady, success, error, count, interval) {
        if (!count) {
            count = 100;
        }
        if (!interval) {
            interval = 20;
        }
        if (isReady()) {
            success();
            return;
        }
        // The call back isn't ready. We need to wait for it
        setTimeout(function () {
            if (!count) {
                // We have run out of retries
                if (error) {
                    error();
                }
            }
            else {
                // Try again
                tryUntilReady(isReady, success, error, count - 1, interval);
            }
        }, interval);
    }
    function initMultiselect() {
        $.localise('ui-multiselect', { language: moya.lang, path: '/_moya/js/jquery/multiselect/js/locale/' });
        $('#forms').multiselect({
            sortable: true,
            searchable: false,
        });
    }
    boxmanInit();

}());
typeof tsBuild === 'function' && tsBuild();})();
